import { useRef, useState, useEffect } from 'react'

declare var google: string

declare global {
	interface Window {
		[key: string]: any
	}
}

export default function useGoogleMaps(key: string) {
	const [initialized, setInitialized] = useState(typeof google !== 'undefined')
	const callback = useRef<string>(Math.random().toString(36).substring(2))
	const fn = callback.current

	useEffect(() =>  {
		if (initialized === false) {
			const script = document.createElement('script')
			script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&callback=${fn}`
			script.async = true
			document.body.appendChild(script)

			// eslint-disable-next-line
			window[fn] = () => {
				delete (window as any)[fn]
				return setInitialized(true)
			}
		}
		// eslint-disable-next-line
	}, [initialized, key])

	return initialized
}
